import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { ComuneContext, ComuneProvider } from './ComuneContext';
import { CompetenzeList, ComuneDetails, ImportDialog } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        navigateTo,
        addBreadcrumbToken,
        setBread,
        goBack
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingComune,
        getComuneAsync,

        isUpdatingComune,
        updateComuneAsync,

        isAddingComune,
        addComuneAsync,

        isLoadingCompetenze,
        getCompetenzeAsync,

        isDeletingUfficioComuneCompetenza,
        deleteUfficioComuneCompetenzaAsync,

        isLoadingComuni,
        getComuniAsync,

        isImportingCompetenze,
        importCompetenzeAsync,

        isLoadingProvince,
        getProvinceAsync,
    } = useContext(ComuneContext)

    const {
        comune,
    } = state;

    const {
        comuneId,
    } = useParams();

    const [openImportDialog, setOpenImportDialog] = useState(false);

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const comuneDetailsActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (comune) {
                    if (window.confirm("Confermare la modifica?")) {
                        await updateComuneAsync(comuneId, data);
                    }
                } else {
                    if (window.confirm("Confermare l'inserimento?")) {
                        await addComuneAsync(data);
                        goBack();
                    }
                }
                break;
            default:
                break;
        }
    }

    const competenzeListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(navigateTo(NavRoutes.ComuneCompetenzaAdd, [comune.id]), "_blank").focus();
                break;
            case "Delete":
                if (window.confirm("Confermare la rimozione dell'ufficio?")) {
                    await deleteUfficioComuneCompetenzaAsync(data.comuneId, data.competenzaId);
                }
                break;
            case "Import":
                setOpenImportDialog(true);
                break;
            default:
                break;
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingComune || isLoadingCompetenze || isDeletingUfficioComuneCompetenza || isImportingCompetenze || isUpdatingComune || isAddingComune);
    }, [isLoadingComune, isLoadingCompetenze, isDeletingUfficioComuneCompetenza, isImportingCompetenze, isUpdatingComune, isAddingComune])

    useEffect(() => {
        if (comune && comuneId) {
            addBreadcrumbToken(comune.denominazioneIt);
        }
    }, [comune]);

    useEffect(() => {
        if (user) {
            if (!comuneId) {
                addBreadcrumbToken("Aggiungi");
            } else {
                getComuneAsync(comuneId);
                getCompetenzeAsync(comuneId);
                getComuniAsync();
            }
            getProvinceAsync();
        }
    }, [user]);

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container columnSpacing={2}>
                    <Grid item xs={12}>
                        <PageHeader
                            save
                            onSaveClick={saveClickHandler}
                            disabled={isLoading}
                            title={`Comune di ${comune?.denominazioneIt ?? ""}`}
                            subtitle={`Gestisci il comune di ${comune?.denominazioneIt ?? ""}`} />
                    </Grid>
                    <Grid item xs={12} lg={comune ? 6 : 12}>
                        <ComuneDetails
                            formRef={formRef}
                            disabled={isLoading}
                            onActionClick={comuneDetailsActionClickHandler} />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        {
                            comune &&
                            <CompetenzeList
                                disabled={isLoading}
                                onActionClick={competenzeListActionClickHandler} />
                        }
                    </Grid>
                </Grid>
            </Container>
            <ImportDialog
                open={openImportDialog}
                handleClose={() => setOpenImportDialog(false)}
                handleSubmit={importComuneId => {
                    if (window.confirm("Confermare l'importazione delle competenze?")) {
                        importCompetenzeAsync(comuneId, importComuneId);
                        setOpenImportDialog(false);
                    }
                }}
            />
        </>
    );
}

export const ComunePage = () => {

    return (
        <ComuneProvider>
            <PageContent />
        </ComuneProvider>
    );
}